import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IS_BIZ_USER, IS_CORP_USER, IS_SOCIAL_USER } from 'reactApp/appHelpers/configHelpers';
import { forceVigboLinkedAccount } from 'reactApp/appHelpers/featuresHelpers/features/vigbo';
import { getBillingDataRequestIfNotLoaded } from 'reactApp/modules/billingData/billingData.module';
import { getBillingDataLoadingState } from 'reactApp/modules/billingData/billingData.selectors';
import { getPastSubscriptionsIfNotLoaded } from 'reactApp/modules/pastSubscriptions/pastSubscriptions.module';
import { PastSubscriptionsSelectors } from 'reactApp/modules/pastSubscriptions/pastSubscriptions.selectors';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { getVigboLinkState, hasActiveVigboTariff, hasFinishedVigboTariff } from 'reactApp/modules/vigbo/vigbo.selectors';
import { VigboAccountLinkState } from 'reactApp/modules/vigbo/vigbo.types';

/**
 * Хук для получения информации о тарифе Vigbo
 * @returns {Object} Объект cо следующми полями: флаг загрузки billing/data 'isLoading', флаг наличия тарифа 'isVigboActiveTariff', флаг завершенного тарифа 'isVigboFinishedTariff'
 */
export const useVigboTariff = () => {
    const dispatch = useDispatch();

    const isPaid = useSelector(UserSelectors.isPaidUser);
    const accountLinkState = useSelector(getVigboLinkState);
    const isLinkedAccount = forceVigboLinkedAccount || accountLinkState === VigboAccountLinkState.linked;

    /**
     * Запрашиваем billing/data если у нас платник или связанный с vigbo аккаунт
     */
    const needBillingData = (!IS_BIZ_USER && !IS_SOCIAL_USER && !IS_CORP_USER && isPaid) || isLinkedAccount;

    useEffect(() => {
        /**
         * В целом диспатч getBillingDataRequestIfNotLoaded где-то обязательно происходит, и можно было бы завязаться на него,
         * но эта неявная зависимость может когда-нибудь стрельнуть, поэтому дублируем диспатч тут
         */
        if (needBillingData) {
            dispatch(getBillingDataRequestIfNotLoaded());
            dispatch(getPastSubscriptionsIfNotLoaded());
        }
    }, [needBillingData]);

    const isVigboActiveTariff = useSelector(hasActiveVigboTariff);
    const { isLoading: billindDataLoading, isLoaded: billindDataLoaded } = useSelector(getBillingDataLoadingState);

    const isVigboFinishedTariff = useSelector(hasFinishedVigboTariff);
    const { isLoading: pasSubsLoading, isLoaded: pastSubsLoaded } = useSelector(PastSubscriptionsSelectors.getLoadingState);

    return {
        isLoading: needBillingData && (billindDataLoading || !billindDataLoaded || pasSubsLoading || !pastSubsLoaded),
        isVigboActiveTariff,
        isVigboFinishedTariff,
    };
};
